import React from 'react';
import { useTheme } from '@mui/material';

export const Idea = (props: React.SVGProps<SVGSVGElement>) => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryColor },
    } = theme.colors.other.icon;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={52} height={52} fill="none" {...props}>
            <path
                fill={primaryColor}
                d="M38.384 19.12c0 2.632-.817 5.057-2.21 7.06-.353.508-.757 1.058-1.17 1.635-1.092 1.505-2.33 3.199-3.268 4.91-.765 1.393-1.178 2.864-1.393 4.291h2.787c.189-1.031.507-2.038 1.014-2.966.852-1.548 1.91-3.002 2.967-4.455.448-.61.895-1.221 1.325-1.84a15.054 15.054 0 0 0 2.7-8.626C41.136 10.76 34.36 3.984 26 3.984c-8.359 0-15.136 6.777-15.136 15.136 0 3.208.998 6.183 2.7 8.626.43.619.878 1.23 1.325 1.84 1.058 1.445 2.116 2.898 2.967 4.455.507.929.826 1.935 1.015 2.967h2.786c-.215-1.428-.628-2.898-1.393-4.291-.937-1.72-2.176-3.415-3.268-4.911a64.316 64.316 0 0 1-1.17-1.634 12.26 12.26 0 0 1-2.21-7.052c0-6.837 5.547-12.384 12.384-12.384 6.837 0 12.384 5.547 12.384 12.384Zm-16.28 23.392h7.783a4.14 4.14 0 0 1-3.895 2.752 4.14 4.14 0 0 1-3.896-2.752h.008Zm-2.984-1.376a6.878 6.878 0 0 0 6.88 6.88 6.878 6.878 0 0 0 6.88-6.88v-.456a.921.921 0 0 0-.92-.92H20.032a.921.921 0 0 0-.92.92v.456h.008ZM26 12.24a1.38 1.38 0 0 0-1.376 1.376v11.008c0 .757.62 1.376 1.376 1.376a1.38 1.38 0 0 0 1.376-1.376V13.616A1.38 1.38 0 0 0 26 12.24Zm2.064 19.264a2.064 2.064 0 1 0-4.129 0 2.064 2.064 0 0 0 4.13 0Z"
            />
        </svg>
    );
};

export default Idea;
